export default __webpack_public_path__ + "static/media/heavyrain.99fea6b3.mp4";